/**
 * This function is set the sort order on the activeSortColumn
 * @param activeSortColumn
 * @param defaultSortOrder
 * @param sortOrder
 * @param dataIndex
 */
export const sortOrder = (activeSortColumn, defaultSortOrder, sortOrder, dataIndex) => {
  if (sortOrder === '-') {
    return {
      sortOrder: false
    };
  }
  if (activeSortColumn !== dataIndex) return {};
  return {
    ...(defaultSortOrder && {
      defaultSortOrder
    }),
    ...(sortOrder && {
      sortOrder
    })
  };
};